import { Link } from "react-router-dom";
import { CareShell, Panel } from "../../components/care/CareLayout";
import { actionCards } from "./careData";

export default function HomePage() {
  return (
    <CareShell className="workspace">
      <section className="home-action-panel">
        <div className="home-action-head">
          <div className="page-title">
            <h1>What would you like to do today?</h1>
            <p>Choose an action below to provide great care and stay organized.</p>
          </div>
          <div className="today-summary" aria-label="Today's care summary">
            <span><strong>12</strong> due soon</span>
            <span><strong>5</strong> open incidents</span>
            <span><strong>24</strong> staff on duty</span>
          </div>
        </div>
        <div className="action-grid">
          {actionCards.map(([icon, title, text, tone]) => (
            <Link
              className="action-card"
              to={title === "Add a New Resident" ? "/residents/new" : title.includes("Assessment") ? "/assessments" : title.includes("Care Plan") ? "/care-plans/negotiated" : "/dashboard"}
              key={title}
            >
              <span className={`round-icon ${tone}`}><i className={`ti ${icon}`} /></span>
              <div><h2>{title}</h2><p>{text}</p></div>
              <i className="ti ti-arrow-right arrow" />
            </Link>
          ))}
        </div>
      </section>
      <div className="split-grid single-column">
        <Panel title="Recent activity" action="View all">
          {[
            ["ti-clipboard-check", "Assessment completed for Margaret Johnson", "Today at 9:15 AM", "Completed"],
            ["ti-note", "Daily note added for Robert Williams", "Yesterday at 4:30 PM", "Note Added"],
            ["ti-heart-handshake", "Care plan updated for Linda Thompson", "May 12 at 11:20 AM", "Plan Updated"],
          ].map(([icon, title, time, status]) => (
            <div className="list-row" key={title}>
              <span className="tiny-icon"><i className={`ti ${icon}`} /></span>
              <div><strong>{title}</strong><small>{time}</small></div>
              <em>{status}</em>
            </div>
          ))}
          <Link className="text-action" to="/dashboard">View all activity <i className="ti ti-arrow-right" /></Link>
        </Panel>
      </div>
    </CareShell>
  );
}
